import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { baseURL } from "../constants/Api";
import axios from "axios";
import ButtonLoader from "./loaders/ButtonLoader";
import { useNavigate } from "react-router-dom";
import { EarlyCheckInSubmitButtonClick } from "../utils/Analytics";

function EarlyCheckin(props) {
  const earlyCheckin = props.earlyTimeArray;
  // console.log("earlyCheckin================",earlyCheckin);
  const [is_edit ,setis_edit] = useState(false);
  useEffect(() => {
    if (props.is_editStatus === true) {
    console.log( "props.is_editeStatus=====================",props.is_editStatus);
      setis_edit(true);
    } else {
      setis_edit(false);
    }
  }, [props.is_editStatus]);
  // const earlyCheckin = [];
  const navigate = useNavigate();
  const [reqTime, setReqTime] = useState("");
  const [earlyDisable, setEarlyDisable] = useState(false);
  const [reqMsg, setReqMsg] = useState(false);
  const [earlyInput, SetEarlyInput] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const hotelId = localStorage.getItem("hotel-id");
  const guestId = localStorage.getItem("guestId");
  const reservationId = localStorage.getItem("guestReservationId");
  const [loading, setLoading] = useState(false);
  const appUserId = localStorage.getItem("appUserId");
  const idofReservetion = localStorage.getItem("reservationId");
  const [comment, setComment] = useState('');
  // const activebutton = localStorage.getItem('earlyRequested');
  const [activebutton, setactivebutton] = useState(false);
  const getCheckInStatus = () => {
    var data = JSON.stringify({
      type: 5, // for earlycheckin
      reservationId: props.bookingParams.reservationId,
    });
    var config = {
      method: "post",
      url: `${baseURL}/api/getCurrentStatus`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    
    axios(config)
      .then(function (response) {
        setReqTime(response.data.data[0].time);
        if (response.data.data.length !== 0) {
          SetEarlyInput(response.data.data[0].time);
          setReqTime(response.data.data[0].time);
          if (response.data.data[0].currentStatus == "Accepted") {
            setEarlyDisable(true);
            setReqMsg(false);
          } else if (response.data.data[0].currentStatus == "Requested") {
            setReqMsg(true);

            if (
              document.getElementById(response.data.data[0].time + "ERL") !=
              null
            ) {
              document.getElementById(
                response.data.data[0].time + "ERL"
              ).checked = true;
            }
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const earlyinput = (event) => {
    SetEarlyInput(event.target.value);
    setError("");
  };

  const submitEarlyReq = async (e, param) => {
    EarlyCheckInSubmitButtonClick();
    e.preventDefault();
    if (!param && earlyInput == "") {
      setError("Please select input..");
    } else {
      setLoading(true);
      try {
        await axios({
          method: "post",
          url: `${baseURL}/api/earlyCheckinLateCheckout`,
          data: {
            hotelId,
            reservationId: props.bookingParams.reservationId,
            guestId,
            requestType: 1,
            requestedTime: param ? param : earlyInput,
            comments: comment,
            appUserId,
            ...(is_edit === true && {is_edit}),
          },
          headers: { "Content-Type": "application/json" },
        }).then(function (response) {
          if (response.data.success != true) {
            setError("Something went wrong..");
            setLoading(false);
          } else {
            setError("");
            setLoading(false);
             setSuccess("successfully Requested");
            setis_edit(false);
            // localStorage.setItem("earlyRequested", true);
            setTimeout(() => {
              setSuccess("");
              props.hide();
              navigate("../order-history")
            }, 1000);
          }
        });
      } catch (error) {
        setLoading(false);
        setError("Something went wrong..");
      }
    }
  };

  function closeModal() {
    props.hide();
  }

  const datetime = props?.bookingParams?.hotelDetails?.checkInTime;
  const time = datetime?.split(' ')[1];
  const convertTo12HourFormat = (timeStr) => {
    console.log(timeStr)
    const date = new Date(`1970-01-01T${timeStr}`);
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return date.toLocaleTimeString([], options);
  };
  const formattedTime = convertTo12HourFormat(time);


  useEffect(() => {
    getCheckInStatus();
    console.log( props?.bookingParams)
  }, [props]);





  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-[#171538] p-4 pt-5 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  ></Dialog.Title>
                  <div className="doc-modal flex-col items-center justify-center mt-2">
                    <div className="w-full flex justify-between items-center mt-5  pb-3 border-b  border-gray-500">
                      <div className="head-sub">Hotel Check-in Time</div>
                      <div className="hotel-time">{formattedTime ? formattedTime : ''}</div>
                    </div>
                    <div className="label mt-3">check-in before</div>
                    {earlyDisable ? (
                      <div className="py-2 text-sm">
                        Early check-in accepted for {reqTime} hours before
                        Check-in time
                      </div>
                    ) : (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          earlyCheckin?.length !== 0
                            ? submitEarlyReq(e, "")
                            : submitEarlyReq(e, 1);
                        }}
                      >
                        <div>
                          {earlyCheckin?.length != 0 ? (
                            <div className=" grid grid-cols-2 gap-6 mt-4">
                              {earlyCheckin?.map((checkinItem, i) => (
                                <div
                                  key={i}
                                  id={checkinItem + "time"}
                                  className="p-3 rounded text-sm sm:text-base flex justify-between px-6 sm:px-3"
                                >
                                  {checkinItem} hr
                                  <input
                                    className="radio"
                                    id={checkinItem + "ERL"}
                                    onChange={earlyinput}
                                    type="radio"
                                    value={checkinItem}
                                    name="earlyCheckin"
                                  />
                                  <label htmlFor={checkinItem + "ERL"}></label>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="">
                              <div className="p-3 rounded text-sm sm:text-base flex gap-2 px-6 sm:px-3">
                                <input checked id="1hrInput" type="radio" />
                                <label htmlFor="1hrInput"></label>
                                <span>1 hr</span>{" "}
                              </div>

                              <div className="text-xs  text-left mt-1 ">
                                Early check-in is limited to one hour prior to
                                the check-in time.
                              </div>
                            </div>
                          )}
                          <div className=" mt-3">
                            <label className="border-gray-500 mt-2 mb-3"> comment if any</label>
                            <textarea placeholder="Eg: will reach early at the station " className="rounded-[5px] bg-[#342f4f] mt-1 text-[white] text-[14px] border-none outline-none px-[8px] py-[8px]  w-full h-[100px]" value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
                          </div>
                          <button
                            disabled={activebutton}
                            // className="upload-btn w-full mt-5 relative"
                            className={` ${activebutton ? 'upload-btnactive' : 'upload-btn'} w-full mt-5 relative`}
                          >
                            <span className="px-[5px]"> Submit</span>
                            {loading && <ButtonLoader />}
                          </button>
                          {activebutton && (
                            <span className={`w-full mt-2 ${activebutton ? 'flex justify-center items-center text-[red]' : ""}`}>
                              Early Check-in Request already Submitted.
                            </span>
                          )}

                          {/* {earlyValidation ? (
                            <div className="flex mt-3 text-red-600 text-xs">
                              Please select an input
                            </div>
                          ) : null} */}
                        </div>
                      </form>
                    )}
                  </div>
                  {error && (
                    <div className="w-full flex justify-center">
                      <div className="error-doc text-center mt-3">{error}</div>
                    </div>
                  )}
                  {success && (
                    <div className="w-full flex justify-center">
                      <div className="success-doc text-center mt-3">
                        {success}
                      </div>
                    </div>
                  )}
                  <div className="absolute top-2 right-2 ">
                    <button
                      type="button"
                      className="outline-none rounded-full hover:bg-gray-600"
                      onClick={closeModal}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="white"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default EarlyCheckin;
